export default __webpack_public_path__ + "static/media/webdesign.1cc66ff3.png";